<template>
  <div class="inscriptionDetails">
    <b-container>
      <b-row>
        <h1>Inscription Details</h1>
      </b-row>
      <b-row>
        <b-button variant="primary" @click="backToInscriptions">Back</b-button>
      </b-row>
      <b-row>
        <b-tabs class="mt-3">
          <b-tab title="info" active>
            <div>
              <b-row v-if="this.inscription !== null" class="mt-2">
                <b-col cols="6">
                  <label for="sales" class="bold">Sales</label>
                    <p>{{ this.inscription.sales.name }}</p>
                  </b-col>
                  <b-col cols="6">
                    <label for="order_number" class="bold">Order #</label>
                  <p>{{ this.inscription.order_number }}</p>
                </b-col>
                <b-col cols="6">
                  <label for="order_date" class="bold">Order Date</label>
                    <p>{{ this.inscription.order_date }}</p>
                  </b-col>
                  <b-col cols="6">
                    <label for="status" class="bold">Status</label>
                    <p>{{ this.inscription.status }}</p>
                  </b-col>
                  <b-col cols="6">
                    <label for="deposit_date" class="bold">Deposit Date</label>
                    <b-button v-if="this.inscription.deposit_date.length == 0">Add deposit date</b-button>
                    <p>{{ this.inscription.deposit_date }}</p>
                </b-col>
                <b-col cols="6" v-if="this.inscription.deposit_date.length > 0">
                  <label for="request_proof_date" class="bold">Request Proof Date</label>
                  <b-button v-if="this.inscription.request_proof_date.length == 0">Add deposit date</b-button>
                    <p>{{ this.inscription.request_proof_date }}</p>
                  </b-col>
                  <b-col cols="6" v-if="this.inscription.request_proof_date.length > 0">
                    <label for="comfirm_proof_date" class="bold">Comfirm Proof Date</label>
                    <b-button v-if="this.inscription.comfirm_proof_date.length == 0">Add deposit date</b-button>
                    <p>{{ this.inscription.comfirm_proof_date }}</p>
                </b-col>
                <b-col cols="6" v-if="this.inscription.comfirm_proof_date.length > 0">
                  <label for="customer_sign_date" class="bold">Customer Sign Date</label>
                  <b-button v-if="this.inscription.customer_sign_date.length == 0">Add deposit date</b-button>
                    <p>{{ this.inscription.customer_sign_date }}</p>
                  </b-col>
                  <b-col cols="6" v-if="this.inscription.customer_sign_date.length > 0">
                    <label for="sent_signed_proof_date" class="bold">Sent Signed Proof Date</label>
                    <b-button v-if="this.inscription.sent_signed_proof_date.length == 0">Add deposit date</b-button>
                  <p>{{ this.inscription.sent_signed_proof_date }}</p>
                </b-col>
                <b-col cols="6" v-if="this.inscription.sent_signed_proof_date.length > 0">
                  <label for="complete_date" class="bold">Complete Date</label>
                  <b-button v-if="this.inscription.complete_date.length == 0">Add deposit date</b-button>
                    <p>{{ this.inscription.complete_date }}</p>
                  </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </b-row>
    </b-container>

    <b-modal id="inscription-add-date" hide-footer title="Add a date">
      <b-container>
        <b-row>
          <b-col cols="6">
            <label for="new_order_number">Order number:</label>
            <input type="text" id='new_order_number' v-model="new_order_number" class="form-control">
          </b-col>
        </b-row>
      </b-container>
      <div class="mt-2 align-right">
        <b-button @click="hideModal('create-inscription')"> Cancel </b-button>
          <b-button class="ml-1" variant="primary" @click="addDate()"> Add </b-button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'InscriptionDetails',
  props: {
    user: Object,
    selectedInscriptionId: String,
  },
  data() {
    return {
      inscription: null,
    }
  },
  created() {
    firebase.firestore().collection('inscriptions').doc(this.selectedInscriptionId).onSnapshot((doc) => {
      this.inscription = doc.data();
    });
  },
  mounted() {

  },
  methods: {
    backToInscriptions() {
      this.$emit('backToInscriptions', 'Inscriptions');
    },
  }
}
</script>
